import checkout from "./form";

const {
  formField: {
    date,
    startDate,
    endDate,
    numberContract,
    supplementaryForThe,
    taxAlternatePayerId,
    taxAlternatePayerName,
    taxAgencyName,
    taxId,
    taxAgentContract,
    taxAgentContractDate,
    certificate,
    fullName,
    firstTime,
    signer,
    timeSign,
  },
} = checkout;

const initialValues = {
  [date.name]: "",
  [startDate.name]: "",
  [endDate.name]: "",
  [numberContract.name]: "",
  [firstTime.name]: false,
  [supplementaryForThe.name]: "",
  [taxAlternatePayerId.name]: "",
  [taxAlternatePayerName.name]: "",
  [taxAgencyName.name]: "",
  [taxId.name]: "",
  [taxAgentContractDate.name]: "",
  [taxAgentContract.name]: "",
  [certificate.name]: "",
  [fullName.name]: "",
  [signer.name]: "",
  [timeSign.name]: "",
};

export default initialValues;
